import React, { Fragment } from "react";
import ContentWrapper from "components/public-dashboard/components/contentWrapper";
import Content from "./content";
import Header from "./header";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";

export default function Partners() {
    useDocumentTitle(
    "Agent Onboarding - Documents Required | YOOZ",
    "Seamless, hassle-free Sign Up. Join over 120 Bill Pay Agents who collect Bill Payments for major utilities. Become the go to Bill Pay center in your community."
  );

  return (
    <Fragment>
      <ContentWrapper>
        <Header />
        <Content />
      </ContentWrapper>
    </Fragment>
  );
}
